export default __webpack_public_path__ + "static/media/atmosphereNegative.80a33951.webp";